module.exports = __webpack_public_path__ + "static/media/next_grey.99c7b0ef.svg";